import dateFormat from 'dateformat';
import { getMonth, getYear, getAbbrMonthYear, getPaddedDate } from './../../../../../../helpers/common/date-util';

export const months = [{"id": 1, "name": "January"},
    {"id": 2, "name": "February"},
    {"id": 3, "name": "March"},
    {"id": 4, "name": "April"},
    {"id": 5, "name": "May"},
    {"id": 6, "name": "June"},
    {"id": 7, "name": "July"},
    {"id": 8, "name": "August"},
    {"id": 9, "name": "September"},
    {"id": 10, "name": "October"},
    {"id": 11, "name": "November"},
    {"id": 12, "name": "December"}];

export const formatEndDate = (date) => {
    return !date || date === "1970-01-01T00:00:00.000Z" || date === "Present" ? 'Present' : getAbbrMonthYear(date);
};

const removeStartingZero = (date) => {
    if (date) {
        return date.length > 1 && date[0] === "0" ? date[1] : date;
    }
    return null;
};

export const handleDates = (start_date, end_date) => {
    let startMonth = !start_date ? null : getMonth( start_date ),
        startYear = !start_date ? null : getYear( start_date ),
        endMonth = !end_date || end_date === 'Present' ? null  : getMonth( end_date ),
        endYear = !end_date || end_date === 'Present' ? null : getYear( end_date );
         
    let startMonthLabel = months[ +startMonth - 1 ];
    let endMonthLabel = months[ endMonth - 1 ];

    return {startMonth: startMonthLabel, startYear, endMonth: endMonthLabel, endYear}
};

export const handleSingleDate = date => {
    let day = !date ? null : getPaddedDate( date ),
        month = !date ? null : getMonth( date ),
        year = !date ? null : getYear( date );
        
    let monthLabel = months[ month - 1 ];

    return {day, month : monthLabel, year}
};

// to order a list with both start and end date
export const orderByEndDate = (list) => {
    list
        .sort((a, b) => {
            if (a.end_date === null || a.end_date === undefined || a.end_date === "" || a.end_date === 'Present') a.end_date = "1970-01-01T00:00:00.000Z";
            if (b.end_date === null || b.end_date === undefined || b.end_date === "" || b.end_date === 'Present') b.end_date = "1970-01-01T00:00:00.000Z";

            return ((new Date(b.end_date)).getTime()) - ((new Date(a.end_date)).getTime());
        })
        .sort((a, b) => {

            if (a.end_date === b.end_date) return ((new Date(b.start_date)).getTime()) - ((new Date(a.start_date)).getTime());
        })
        .map(job => {

            if (job.end_date === "1970-01-01T00:00:00.000Z") return job.end_date = null;
        });

    const listNoEndDate = [...list].filter(e => e.end_date === null);
    const regularList = [...list].filter(e => e.end_date !== null);

    return listNoEndDate.concat(regularList);
};

// to order list with single date and checkbox for 'ongoing',
export const orderByDateOrCurrent = (list) => {
  list
      .sort((a, b) => {
          if (a.qualification_date === 'Present' || !a.qualification_date ) a.qualification_date = "1970-01-01T00:00:00.000Z";
          if (b.qualification_date === 'Present' || !a.qualification_date) b.qualification_date = "1970-01-01T00:00:00.000Z";
          return ((new Date(b.qualification_date)).getTime()) - ((new Date(a.qualification_date)).getTime());
      })
      .sort((a, b) => {
          if (a.qualification_date === b.qualification_date) return ((new Date(b.qualification_date)).getTime()) - ((new Date(a.qualification_date)).getTime());
      })
      .map(course => {

          if (course.qualification_date === "1970-01-01T00:00:00.000Z") return course.qualification_date = null;
      });

    const listNoEndDate = [...list].filter(e => e.qualification_date === "Present" || !e.qualification_date);
    const regularList = [...list].filter(e => e.qualification_date && e.qualification_date !== 'Present');

    return listNoEndDate.concat(regularList);
};

// to order a list with one date
export const orderByDate = (list) => {
    list
        .sort((a, b) => ((new Date(b.date)).getTime()) - ((new Date(a.date)).getTime()));

    return list;
};





// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/dates/dateHelpers.js